import { motion as Motion } from "framer-motion";
import styles from "./FooterDesktop.module.scss";

export default function FooterDesktop() {
  return (
    <Motion.div
      className={styles.footerWrap}
      initial={{ y: 50, opacity: 0, scale: 0.96 }}
      animate={{ y: 0, opacity: 1, scale: 1 }}
      transition={{ type: "spring", stiffness: 140, damping: 16, delay: 0.05 }}
    >
      <footer className={styles.footer}>
        <span className={styles.orbit} aria-hidden="true" />
        <span className={styles.glow} aria-hidden="true" />
        <span className={styles.scan} aria-hidden="true" />

        <span className={styles.mainLine}>
          <span className={styles.dot} aria-hidden="true" />
          Powered by Free Thinkers
        </span>

        <span className={styles.site}>notyu.com</span>
      </footer>
    </Motion.div>
  );
}
